
<div
  class="marketplace-toggle-wrapper"
  id="marketplace-toggle-wrapper"
  [class.toggle-pulse]="isHighlighted"
>
  <span class="toggle-label">Available for Consultations</span>

  <label class="toggle-switch" [class.disabled]="isSaving">
    <input
      type="checkbox"
      [checked]="isListed"
      (click)="$event.preventDefault(); onToggleClick()"
      [attr.aria-label]="isListed ? 'Turn off consultation availability' : 'Turn on consultation availability'"
    />
    <span class="slider" [class.on]="isListed" [class.off]="!isListed"></span>
  </label>

  <!-- Hover-only tooltip; no info icon -->
  <div class="toggle-tooltip" *ngIf="isListed">
    <strong>You're online!</strong>
    <p>Clients can discover your profile and book consultations.</p>
    <p>Turning this off pauses incoming consultations. Keep it on to stay visible and grow your business!</p>
  </div>
  <div class="toggle-tooltip" *ngIf="!isListed">
    <strong>You're currently offline!</strong>
    <p>Incoming consultation requests are paused.</p>
    <p>Turn this on anytime to receive new consultation requests.</p>
  </div>
</div>